import { render } from "./project.vue?vue&type=template&id=02a29a42&scoped=true"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"

import "./project.vue?vue&type=style&index=0&id=02a29a42&lang=less&scoped=true"

import exportComponent from "E:\\suooter\\36live\\live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a29a42"]])

export default __exports__